import { render, staticRenderFns } from "./page-top-header.vue?vue&type=template&id=63c6920b&scoped=true&"
import script from "./page-top-header.vue?vue&type=script&lang=js&"
export * from "./page-top-header.vue?vue&type=script&lang=js&"
import style0 from "./page-top-header.vue?vue&type=style&index=0&id=63c6920b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c6920b",
  null
  
)

export default component.exports